import { PHASE } from "../../../common/constants.ts";
import { g } from "../../util/index.ts";
import type { PlayerWithoutKey } from "../../../common/types.ts";
import { timeBetweenGames } from "../../../common/timeBetweenGames.ts";
import { isPidLocked } from "../league/getRosterLock.ts";

const isUntradable = (
	p: PlayerWithoutKey,
):
	| {
			untradable: false;
			untradableMsg?: string;
	  }
	| {
			untradable: true;
			untradableMsg: string;
	  } => {
	// Contest roster lock: locked players can never be traded, not even in God
	// Mode. Checked first so it can't be bypassed. `pid` is undefined only for
	// not-yet-saved players, which are never locked.
	if (p.pid !== undefined && isPidLocked(p.pid)) {
		return {
			untradable: true,
			untradableMsg: "This player is locked by the challenge and can't be traded",
		};
	}

	if (!g.get("godMode")) {
		if (
			p.contract.exp <= g.get("season") &&
			g.get("phase") > PHASE.PLAYOFFS &&
			g.get("phase") < PHASE.FREE_AGENCY
		) {
			// If the season is over, can't trade players whose contracts are expired
			return {
				untradable: true,
				untradableMsg: "Cannot trade expired contracts",
			};
		}

		if (p.gamesUntilTradable > 0) {
			// Can't trade players who recently were signed or traded
			return {
				untradable: true,
				untradableMsg: `Cannot trade recently-acquired player for ${
					p.gamesUntilTradable
				} more ${timeBetweenGames(p.gamesUntilTradable)}`,
			};
		}
	}

	return {
		untradable: false,
	};
};

export default isUntradable;
